import { APP_NAME, COMMITMENT_LIST } from "../constants";
import IconList from "./IconList";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section id="about">
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <p className="texts">
              {APP_NAME} is committed to fostering a safer, more harmonious
              community by providing exceptional dog training services and
              raising well-behaved canine citizens. Our mission is to partner
              with individuals, families, and organizations to:
            </p>
            <IconList items={COMMITMENT_LIST} />
          </div>
          <div className="col-12">
            <motion.p
              initial={{ opacity: 0, filter: "blur(30px)" }}
              whileInView={{ opacity: 1, filter: "blur(0px)" }}
              transition={{ duration: 0.5, ease: "linear" }}
              viewport={{ once: true }}
              className="texts"
            >
              When it comes to entrusting the training of your beloved canine
              companion, choosing us is paramount. We have have established
              ourselves as industry leaders by consistently delivering
              exceptional training services, adhering to ethical standards, and
              prioritizing the well-being of both dogs and their owners. We have
              invested in training our staff and staying up-to-date with the
              latest advancements in canine behavior and training techniques.
              This ensures that your dog is receiving the highest quality care
              from individuals who are knowledgeable and skilled in their field.
            </motion.p>
          </div>
          <div className="col-12">
            <motion.p
              initial={{ opacity: 0, filter: "blur(30px)" }}
              whileInView={{ opacity: 1, filter: "blur(0px)" }}
              transition={{ duration: 1, ease: "linear" }}
              viewport={{ once: true }}
              className="texts"
            >
              Another advantage of choosing us is our commitment to customer
              satisfaction. We understand that your dog is more than just a pet;
              they're a beloved family member. We ensure that both you and your
              dog have a positive and rewarding training experience. From
              providing personalized training plans to offering ongoing support
              and guidance, prioritizing your satisfaction.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
